var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarningYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7651 11.3847L9.62516 0.906269C8.92182 -0.30209 7.07793 -0.30209 6.37459 0.906269L0.234626 11.3847C-0.449705 12.557 0.443727 13.9998 1.86942 13.9998H14.1493C15.556 14.0179 16.4495 12.5751 15.7651 11.3847ZM7.85731 3.53941H8.10443C8.4656 3.53941 8.76975 3.82797 8.75074 4.17064L8.63668 8.84176C8.63668 8.98604 8.50362 9.11229 8.35155 9.11229H7.61019C7.45811 9.11229 7.32505 9.00408 7.32505 8.84176L7.21099 4.17064C7.19199 3.82797 7.49613 3.53941 7.85731 3.53941ZM7.99037 11.8897C7.45811 11.8897 7.0209 11.4749 7.0209 10.9699C7.0209 10.4649 7.45811 10.0501 7.99037 10.0501C8.52263 10.0501 8.95984 10.4649 8.95984 10.9699C8.97885 11.4749 8.54164 11.8897 7.99037 11.8897Z",
    fill: "#FC9700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningYellow);
export default __webpack_public_path__ + "static/media/ic_warning_yellow.55b7cfa22d792c7631ac5c24cc1349b3.svg";
export { ForwardRef as ReactComponent };